import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchTtenList = createAsyncThunk("fetchTtenList", async (params = {}, { rejectWithValue }) => {
    
    try {
        const response = await axiosHttp.get(`tten/getavbttenlist`, { params }); 
        if (response.data && response.data.status === "success") {
            return response.data.data || [];
        } else {
            return rejectWithValue(response.data?.message || "Failed to fetch Tten data");
        }
    } catch (error) {
        console.error("API Error:", error);
        return rejectWithValue(error.response?.data?.message || "Something went wrong");
    }
});

const TtenListSlice = createSlice({
    name: "TtenListSlice",
    initialState: {
        isLoading: false,
        data: null,
        error: null,
    },

    extraReducers: (builder) => {
        builder.addCase(fetchTtenList.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(fetchTtenList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
            state.page = action.payload.currentPage;
            state.total = action.payload.total;
        });

        builder.addCase(fetchTtenList.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});

export default TtenListSlice.reducer;